<template>
  <v-container id="employee-report" fluid tag="section">
    <filter-form :filterForm="filterForm" />
    <!-- <DepartmentReportTable
      :filter-form="filterForm" :employeeReports="employeeReports" :totalReports="totalReports"
    />
    <common-no-result
      v-if="!employeeReports.length || totalItem === 0"
    /> -->
    <v-card>
      <DepartmentReportTable
        :employeeReports="employeeReports" :totalReports="totalReports" :roleName="roleName"
      />
      <common-no-result
        v-if="!employeeReports.length || totalItem === 0"
      />
      <v-row class="mt-4">
        <v-col
            cols="12"
            sm="6"
        />
        <v-col
            cols="12"
            sm="6"
        >
          <v-pagination
            v-if="totalItem > limit"
            v-model="currentPage"
            class="justify-sm-end"
            :length="getTotalItem(totalItem, limit)"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import TokenService from '../../../../helpers/token';
import * as moment from 'moment'
import FilterForm from './components/FilterForm.vue'
import DepartmentReportTable from './components/DepartmentReportTable'
import { formatDate } from '@/helpers/utils'
import RepositoryFactory from "@/repositories/RepositoryFactory";
import { filterShiftCallCenter } from '../../../../helpers/constants'

const ReportRepository = RepositoryFactory.get('report');
const DepartmentRepository = RepositoryFactory.get('department')

export default {
  components: { FilterForm, DepartmentReportTable },
  data () {
    return {
      filterShiftCallCenter,
      employeeReports: [],
      filterForm: {
        dateRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          departmentId: '',
          shift: [],
          storeId: 0,
          departmentIds: []
        },
      },
      store: [
        {
          text: 'Tất cả',
          value: 0
        },
        {
          text: 'Kho T',
          value: 1
        },
        {
          text: 'Kho C',
          value: 2
        }
      ],
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      errorMessage: '',
      loading: false,
      totalReports: {},
      roleName: _.get(TokenService.getUser(), 'role.name', '')
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getDepartmentReport()
      }
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getDepartmentReport()
        } else {
          this.currentPage = 1
        }
      }
    }
  },
  created () {
    this.getDepartmentReport()
    Bus.$on('department-report-list-filter-thpt', (filterForm) => {
      this.filterForm = filterForm
      this.getDepartmentReport()
      this.currentPage = 1
    })
  },
  beforeDestroy() {
    Bus.$off('department-report-list-filter-thpt');
  },

  methods: {
    async getDepartmentReport () {
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        storeId: this.filterForm.storeId,
        shift: this.filterForm.shift,
        departmentIds: this.filterForm.departmentIds,
        page: this.currentPage - 1,
        limit: this.limit,
        departmentType: 'retail',
        schoolLevelIds: [2]
      }

      // if (!this.isManager()) {
      //   const dataUser = TokenService.getUser() || {};
      //   params.departmentId = dataUser.departmentId;
      // }

      const loader = this.$loading.show()
      const response = await ReportRepository.departmentEmployeeFe(params)
      if (response.success) {
        this.employeeReports = _.get(response, 'data.rows', [])
        this.totalItem = _.get(response, 'data.count', 0)
        this.totalReports = _.get(response, 'data.total', 0)
      }
      loader.hide()
    },
  },
}
</script>
